export default __webpack_public_path__ + "static/media/song.78a419cc.png";